function initPhotoCarousel() {
		jQuery(this).slick({
			mobileFirst: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			prevArrow: '<button type="button" class="slick-prev"><span class="screen-reader-text">Previous Slides</span></button>',
			nextArrow: '<button type="button" class="slick-next"><span class="screen-reader-text">Next Slides</span></button>',
			appendArrows: jQuery(this).parent().find('.block--photo-carousel--navigation--arrows'),
			appendDots: jQuery(this).parent().find('.block--photo-carousel--navigation--dots'),
			dots: true,
			responsive: [
				{
					breakpoint: 782,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
					}
				},
				{
					breakpoint: 480,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						centerMode: true,
						centerPadding: '60px',
					}
				}
			]
		});
}

export {
	initPhotoCarousel
};
